import React from 'react';
import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';
import './App.css';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AppShell from './components/AppShell';

// Landing
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import SparkExperienceSection from './components/SparkExperienceSection';
import HowItWorksSection from './components/HowItWorksSection';
import FeedSection from './components/FeedSection';
import NotificationsSection from './components/NotificationsSection';
import ChatDashboardSection from './components/ChatDashboardSection';
import ForInvestorsSection from './components/ForInvestorsSection';
import ForEntrepreneursSection from './components/ForEntrepreneursSection';
import DifferentiatorsSection from './components/DifferentiatorsSection';
import TestimonialsSection from './components/TestimonialsSection';
import NumbersSection from './components/NumbersSection';
import PlansSection from './components/PlansSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import ParticlesBackground from './components/ParticlesBackground';

// App pages
import AuthPage from './pages/AuthPage';
import AuthCallback from './pages/AuthCallback';
import ResetPassword from './pages/ResetPassword';
import Onboarding from './pages/Onboarding';
import Feed from './pages/Feed';
import BusinessCreate from './pages/BusinessCreate';
import Sparks from './pages/Sparks';
import Chat from './pages/Chat';
import Messages from './pages/Messages';
import NotificationsPage from './pages/NotificationsPage';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import Plans from './pages/Plans';
import Billing from './pages/Billing';
import BillingSuccess from './pages/BillingSuccess';
import AppIndexRedirect from './pages/AppIndexRedirect';

// Admin
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminGuard from './components/AdminGuard';

const Landing = () => (
  <div className="App">
    <ParticlesBackground />
    <Navbar />
    <main className="relative z-10">
      <HeroSection />
      <SparkExperienceSection />
      <HowItWorksSection />
      <FeedSection />
      <NotificationsSection />
      <ChatDashboardSection />
      <ForInvestorsSection />
      <ForEntrepreneursSection />
      <DifferentiatorsSection />
      <TestimonialsSection />
      <NumbersSection />
      <PlansSection />
      <CTASection />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/auth/reset" element={<ResetPassword />} />

          {/* Admin (hidden — reached only via 5-tap on the logo) */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminGuard><AdminDashboard /></AdminGuard>} />
          <Route path="/billing/success" element={<ProtectedRoute><BillingSuccess /></ProtectedRoute>} />
          <Route path="/onboarding" element={<ProtectedRoute requireOnboarded={false}><Onboarding /></ProtectedRoute>} />
          <Route path="/app" element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
            <Route index element={<AppIndexRedirect />} />
            <Route path="feed" element={<Feed />} />
            <Route path="business/new" element={<BusinessCreate />} />
            <Route path="sparks" element={<Sparks />} />
            <Route path="messages" element={<Messages />} />
            <Route path="chat/:sparkId" element={<Chat />} />
            <Route path="notifications" element={<NotificationsPage />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="profile" element={<Profile />} />
            <Route path="plans" element={<Plans />} />
            <Route path="billing" element={<Billing />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
